import React from "react";
import { Box, Typography, IconButton, Divider, Drawer } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Button from "../MUI/Button";
import Icon from "../MUI/Icon";
const SIZE_MAP = {
  small: 340,
  medium: 480,
  large: 640,
};

const SideDrawer = ({
  open = false,
  size = "medium",
  title = "Title",
  content = null,
  onClose,
  actions = null,
  variant = "closeButton",
  setActiveStep,
  activeStep,
  trailingIcon = null,
  steps,
  children,
  isStepper = false,
  jsonData,
  handleDrawerClose,
  ...props
}) => {
  const width = SIZE_MAP[size] || SIZE_MAP.medium;
 
  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "100vh",
        background: "#fff",
        borderRadius: 0,
        display: "flex",
        flexDirection: "column",
        minWidth: width,
        justifyContent: "space-between",
      }}
      {...props}
    >
      <Box
        sx={{
          background: "#601350",
          borderRadius: 0,
          p: "24px",

          ...jsonData?.subNavbarContent?.style,
          display: "flex",
          alignItems: "center",
          position: "sticky",
          top: 0,
          width: "100%",
          zIndex: 1,
        }}
      >
        <Typography
          variant="subtitle1"
          sx={{
            color: "#fff",
            fontWeight: 600,
            flex: 1,
            fontSize: 16,
            ...jsonData?.subNavbarContent?.str1?.style,
          }}
        >
          {jsonData?.subNavbarContent?.str1?.label || "title"}
        </Typography>
   
        {(variant === "trailingIcon" || variant === "closeButtonWithIcon") &&
          trailingIcon}
        {(variant === "closeButton" || variant === "closeButtonWithIcon") &&
          (jsonData?.subNavbarContent?.icn1 ? (
            <Icon style={jsonData?.subNavbarContent?.icn1?.style}>
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                dangerouslySetInnerHTML={{
                  __html: jsonData?.subNavbarContent?.icn1?.icon,
                }}
              />
            </Icon>
          ) : (
            <IconButton
              onClick={handleDrawerClose ? handleDrawerClose : null}
              sx={{ color: "#fff", p: 0.5 }}
              size="small"
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          ))}
      </Box>
      <Divider sx={{ m: 0 }} />

      <Box sx={{ flex: 1, p: 2 }}>{children}</Box>

      <Box
        sx={{
          display: "flex",

          justifyContent: "space-between",
          alignItems: "center",
          px: 2,
          py: 1,
          ...jsonData?.ActionButton?.style,
          maxWidth: "100%",
          width: "100%",
          position: "sticky",
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 2,
          background:
            jsonData?.ActionButton?.style?.backgroundColor &&
            jsonData?.ActionButton?.style?.backgroundColor !== "rgba(0,0,0,0)"
              ? jsonData?.ActionButton?.style?.backgroundColor
              : "white",

          borderTop: "1px solid #e0e0e0",
          justifyContent: activeStep !== 0 ? "space-between" : "flex-end",
        }}
      >
        {isStepper ? (
          <>
            {activeStep !== 0 && (
              <Button
                variant="outlined"
                style={{
                  display: "flex",
                  height: "40px",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "8px",
                  color: "var(--SMA-sys-light-primary, #601350)",
                  textAlign: "center",
                  fontFamily: "Roboto",
                  fontSize: "14px",
                  fontStyle: "normal",
                  fontWeight: 500,
                  lineHeight: "20px",
                  letterSpacing: "0.1px",
                  borderRadius: "100px",
                  border: "1px solid var(--SMA-sys-light-outline, #83727C)",
                  // ...jsonData?.ActionButton?.btn1?.style,
                  flexDirection: "row",
                }}
                onClick={() => setActiveStep(activeStep - 1)}
              >
                {/* {jsonData?.ActionButton?.btn1?.label || "Back"} */}
                Back
              </Button>
            )}
            <Button
              variant="contained"
              disabled={activeStep === steps?.length - 1}
              style={{
                display: "flex",
                height: "40px",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                gap: "8px",
                color: "var(--SMA-sys-light-on-primary, #FFF)",
                textAlign: "center",
                fontFamily: "Roboto",
                fontSize: "14px",
                fontStyle: "normal",
                fontWeight: 500,
                lineHeight: "20px",
                letterSpacing: "0.1px",
                ...jsonData?.ActionButton?.btn2?.style,
                flexDirection: "row",
              }}
              onClick={() => setActiveStep(activeStep + 1)}
            >
              {jsonData?.ActionButton?.btn2?.label || "Continue"}
            </Button>
          </>
        ) : (
          <Button
            variant="contained"
            disabled={activeStep === steps?.length - 1}
            style={{
              display: "flex",
              height: "40px",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              gap: "8px",
              color: "var(--SMA-sys-light-on-primary, #FFF)",
              textAlign: "center",
              fontFamily: "Roboto",
              fontSize: "14px",
              fontStyle: "normal",
              fontWeight: 500,
              lineHeight: "20px",
              letterSpacing: "0.1px",
              ...jsonData?.ActionButton?.btn1?.style,
              flexDirection: "row",
            }}
            onClick={() => alert("Submit action")}
          >
            {jsonData?.ActionButton?.btn1?.label || "Submit"}
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default SideDrawer;
